import React from 'react';
import styles from './index.module.scss';

const ChangeSupplierConfirmationModal = props => {
  const { cancelChange, changeSupplier, toggleModal } = props;

  return (
    <form onSubmit={e => e.preventDefault()} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Change Supplier</div>
            <div className={styles['modal-title']}>Confirm Supplier Change</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            All the added inventory item(s) will be removed. Do you want to continue?
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={cancelChange}
          >
            Cancel
          </button>
          <button
            onClick={changeSupplier}
            className={styles['submit-button']}
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
};

export default ChangeSupplierConfirmationModal;
